import "./ProgrammeStepPreview.scss";

import { Grid } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { useDispatch } from "react-redux";
import classnames from "classnames";
import { useHistory } from "react-router-dom";

import { ReactComponent as LockedIcon } from "../../../assets/img/icons/lockOutline.svg";
import { update_current_tab_index } from "../../../store/actions/updateCurrentViewData";

const Part = ({ title, onClick, locked = true }) => {
  return (
    <button className={classnames("part", { locked })} onClick={onClick}>
      <div className={classnames("part__title-container", { locked })}>
        <h2 className="part__title">{title}</h2>
      </div>
      <ChevronRightIcon fontSize="large" />
    </button>
  );
};

const ProgrammeStepPreview = ({
  title,
  stepNumber,
  parts,
  programmeSlug,
  locked = true,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handlePartClick = (index) => {
    dispatch(update_current_tab_index(index));
    const step = stepNumber < 10 ? `0${stepNumber}` : stepNumber;
    history.push(`/my-path/${programmeSlug}/step-${step}/preview`);
  };

  return (
    <div className={classnames("programme-step", { locked })}>
      <div
        className={classnames("programme-step__indicator", {
          "programme-step__margin": stepNumber > 0,
          "programme-step__locked": locked,
        })}
      >
        <LockedIcon />
      </div>
      <div className="programme-step__container">
        {stepNumber > 0 && <p className="programme-step__title">{title}</p>}
        <Grid container spacing={2}>
          {parts.length > 0 &&
            parts.map((part, idx) => {
              return (
                <Grid item xs={12} key={idx}>
                  <Part title={part} onClick={() => handlePartClick(idx)} />
                </Grid>
              );
            })}
        </Grid>
      </div>
    </div>
  );
};

export default ProgrammeStepPreview;
